import React from "react";
import { Footer, Navbar } from "../components";
import { useSelector, useDispatch } from "react-redux";
import { addCart, delCart } from "../redux/action";
import { Link } from "react-router-dom";
import configData from "../config.json";
import ShowCart from "./ShowCart";


const Cart = () => {
  const state = useSelector((state) => state.handleCart);
  const dispatch = useDispatch();


  const EmptyCart = () => {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 py-5 bg-light text-center">
            <h4 className="p-3 display-5">Your Cart is Empty</h4>
            <Link to="/" className="btn  btn-outline-dark mx-4">
              <i className="fa fa-arrow-left"></i> Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    );
  };

  

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Cart</h1>
        <hr />
        {state.length > 0 ? <ShowCart /> : <EmptyCart />}
        <div className="col-md-4">
        {state.length > 0 ? <Link to="/checkout" className="btn btn-success btn-lg btn-block" > Go to checkout </Link>:""}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Cart;
